import { grey } from "@mui/material/colors";

const styles = {
  container: {
    maxHeight: "calc(100vh - 100px)",
    overflow: "auto",
    width: "100%",
    pb: 10,
  },
  collection: {
    cursor: "pointer",
    py: 1.75,
    px: 2,
    borderBottom: "1px solid #f3f4f6",
    "&:hover": {
      backgroundColor: "#f9fafb",
    },
  },
  collectionTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
  },
  collectionTitleIcon: {
    color: "#99a1af",
    fontSize: 12,
  },
  collectionTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: "#101828",
    lineHeight: "20px",
    letterSpacing: "-0.15px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
    flex: 1,
  },
  collectionActions: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    ml: "auto",
  },
  collectionIconButton: {
    color: grey[500],
    width: 22,
    height: 22,
    "&:hover": {
      color: grey[700],
      backgroundColor: "transparent",
    },
  },
  collectionChevron: {
    color: "#99a1af",
    fontSize: 11,
  },
  badgeRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
    mt: 0.75,
  },
  badgeGreen: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "#eaf5ee",
    color: "#2d7a50",
    fontSize: 10,
    fontWeight: 500,
    lineHeight: "15px",
    letterSpacing: "0.12px",
    borderRadius: 9999,
    px: "8px",
    py: "2px",
  },
  badgeAmber: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "#fffbeb",
    color: "#e17100",
    fontSize: 10,
    fontWeight: 500,
    lineHeight: "15px",
    letterSpacing: "0.12px",
    borderRadius: 9999,
    px: "8px",
    py: "2px",
  },
  badgeIcon: {
    fontSize: 8,
  },
  metaRow: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
    mt: 0.75,
  },
  metaIconGreen: {
    color: "#2d7a50",
    fontSize: 9,
  },
  metaTextGreen: {
    color: "#2d7a50",
    fontSize: 10,
    fontWeight: 500,
    lineHeight: "15px",
    letterSpacing: "0.12px",
  },
  newList: {
    cursor: "pointer",
    py: 2,
    px: 1,
  },
  chevron: {
    color: grey[800],
    fontSize: 12,
  },
  caption: {
    py: 2,
    px: 1,
    borderBottom: "1px solid #f3f4f6",
    fontSize: 12,
  },
  circlePlus: {
    fontSize: 12,
    color: "black",
    width: 25,
    height: 25,
  },
  addCollection: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.75,
    py: 1.75,
    px: 2,
    borderBottom: "1px solid #f3f4f6",
    color: "#99a1af",
    fontSize: 11,
    fontWeight: 500,
    lineHeight: "16px",
    letterSpacing: "0.12px",
    "&:hover": {
      backgroundColor: "#f9fafb",
    },
  },
  addCollectionIcon: {
    fontSize: 9,
  },
};

export default styles;
